import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15e63867&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/components/pages/apiKeysPage/styles/scoped.scss?vue&type=style&index=0&id=15e63867&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e63867",
  null
  
)

export default component.exports